<template>
    <div class="row">
        <div class="col-12 text-center">
            <p class="h5">
                {{ $tc('app.apple.title') }}
            </p>
            <p>
                {{ $tc('app.apple.subtitle') }}
            </p>
            <br>
            <b-img src="/images/stores/apple.svg" fluid alt="Apple" style="max-width: 100%; height: auto;" @click="store"></b-img>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'android',
        methods: {
            store() {
                window.open('https://itunes.apple.com/us/app/vallarta-plus/id1459155307?l=es&ls=1&mt=8', '_blank')
            }
        }
    }
</script>